(function () {
  const STORAGE_KEY = 'sw-fb-likes';

  function storage() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function saveStorage(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* private mode */
    }
  }

  function closest(el, selector) {
    return el && el.closest(selector);
  }

  function initRoot(root) {
    if (!root || root.dataset.swFbReady) return;
    root.dataset.swFbReady = 'true';

    const likes = storage();

    root.querySelectorAll('[data-sw-fb-item]').forEach((item) => {
      const id = item.getAttribute('data-item-id');
      if (likes[id]) {
        setLiked(item, true, false);
      }
    });

    root.addEventListener('click', (event) => {
      const likeBtn = closest(event.target, '[data-sw-fb-like]');
      if (likeBtn) {
        event.preventDefault();
        toggleLike(likeBtn.closest('[data-sw-fb-item]'));
        return;
      }

      const replyBtn = closest(event.target, '[data-sw-fb-reply]');
      if (replyBtn) {
        event.preventDefault();
        openReply(replyBtn.closest('[data-sw-fb-thread]') || replyBtn.closest('[data-sw-fb-item]'));
        return;
      }

      const sortBtn = closest(event.target, '[data-sw-fb-sort-btn]');
      if (sortBtn) {
        event.preventDefault();
        const sort = sortBtn.closest('[data-sw-fb-sort]');
        sort.classList.toggle('is-open');
        return;
      }

      const sortOption = closest(event.target, '[data-sw-fb-sort-option]');
      if (sortOption) {
        event.preventDefault();
        applySort(root, sortOption.dataset.sort);
        const sort = sortOption.closest('[data-sw-fb-sort]');
        sort.classList.remove('is-open');
        sort.querySelector('[data-sw-fb-sort-label]').textContent = sortOption.textContent.trim();
        sort.querySelectorAll('[data-sw-fb-sort-option]').forEach((opt) => {
          opt.classList.toggle('is-active', opt === sortOption);
        });
        return;
      }

      if (!closest(event.target, '[data-sw-fb-sort]')) {
        root.querySelectorAll('[data-sw-fb-sort]').forEach((el) => el.classList.remove('is-open'));
      }
    });

    root.querySelectorAll('[data-sw-fb-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const input = form.querySelector('[data-sw-fb-input]');
        if (!input || !input.value.trim()) return;
        input.value = '';
        let sent;
        if (form.hasAttribute('data-sw-fb-reply-form')) {
          const thread = form.closest('[data-sw-fb-thread]');
          sent = thread && thread.querySelector('[data-sw-fb-sent]');
        } else {
          sent = root.querySelector('[data-sw-fb-composer-sent]');
        }
        form.hidden = true;
        if (sent) sent.hidden = false;
      });
    });

    root.querySelectorAll('[data-sw-fb-input]').forEach((input) => {
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          input.closest('form').dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    });
  }

  function setLiked(item, liked, persist) {
    if (!item) return;
    const btn = item.querySelector('[data-sw-fb-like]');
    const badge = item.querySelector('[data-sw-fb-badge]');
    const countEl = item.querySelector('[data-sw-fb-count]');
    const base = parseInt(item.getAttribute('data-likes'), 10) || 0;
    const next = liked ? base + 1 : base;

    btn.classList.toggle('is-liked', liked);
    btn.textContent = liked ? 'Like' : 'Like';
    countEl.textContent = String(next);
    badge.classList.toggle('is-empty', next < 1);
    badge.setAttribute('aria-label', next + ' likes');
    item.classList.toggle('is-liked', liked);

    if (persist) {
      const id = item.getAttribute('data-item-id');
      const data = storage();
      if (liked) data[id] = true;
      else delete data[id];
      saveStorage(data);
    }
  }

  function toggleLike(item) {
    if (!item) return;
    setLiked(item, !item.classList.contains('is-liked'), true);
  }

  function openReply(thread) {
    if (!thread) return;
    const form = thread.querySelector('[data-sw-fb-reply-form]');
    const sent = thread.querySelector('[data-sw-fb-sent]');
    if (!form || (sent && !sent.hidden)) return;
    form.hidden = !form.hidden;
    if (!form.hidden) {
      const input = form.querySelector('[data-sw-fb-input]');
      if (input) input.focus();
    }
  }

  function applySort(root, type) {
    const list = root.querySelector('[data-sw-fb-list]');
    if (!list) return;
    const threads = Array.from(list.children);
    threads.sort((a, b) => {
      const aLikes = threadScore(a, 'likes');
      const bLikes = threadScore(b, 'likes');
      const aHours = threadScore(a, 'hours');
      const bHours = threadScore(b, 'hours');
      if (type === 'newest') return aHours - bHours;
      if (type === 'oldest') return bHours - aHours;
      return bLikes - aLikes;
    });
    threads.forEach((thread) => list.appendChild(thread));
  }

  function threadScore(thread, key) {
    if (key === 'likes') {
      let total = 0;
      thread.querySelectorAll('[data-sw-fb-item]').forEach((item) => {
        const base = parseInt(item.getAttribute('data-likes'), 10) || 0;
        total += item.classList.contains('is-liked') ? base + 1 : base;
      });
      return total;
    }
    return parseInt(thread.getAttribute('data-hours'), 10) || 0;
  }

  function initAll() {
    document.querySelectorAll('[data-sw-fb]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-sw-fb]');
    if (root) {
      delete root.dataset.swFbReady;
      initRoot(root);
    }
  });
})();
